<template>
  <a-modal
    :visible="visible"
    :title="isEdit ? $t('edit') : $t('create')"
    :ok-text="$t('ok')"
    :cancel-text="$t('close')"
    :width="800"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="back" :loading="loading" @click="handleCancel">
        {{ $t('cancel')}}
      </a-button>
      <a-button :loading="loading" type="danger" @click="() => getDataSourse()">
        {{ $t('page_calendar_reset')}}
      </a-button>
      <a-button :loading="loading" type="primary" @click="() => handleOk()">
        {{ $t('save')}}
      </a-button>
    </template>
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-row :gutter="24">
        <a-col
          :span="24"
        >
        <a-form-item :label="$t('page_system_coding_rules')"
         :style="isEdit? {'display':'none'}:{'display':'block'}">
          <a-select
          show-search
          :filter-option="filterOption"
          v-decorator="[
          'codeRuleId',
          { rules: [
            { message: $t('page_system_coding_rules') },
            { max: 48, message: this.$t('page_system_coding_rules') }] }
          ]"
          :placeholder="$t('please_select') + $t('page_system_coding_rules')"
          @change="handleSelectChange"
          allowClear
          >
            <template v-for="item in maintainList">
              <a-select-option :value="item.id" :key="item.id" >
                {{item.name}}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
          <a-form-item :label="$t('page_plan_maintenance_code')">
            <a-input
              :disabled="disabled || isEdit"
              :maxLength="32"
              v-decorator="[
                'code',
                { initialValue: dataSourse.code || '',
                  rules: [
                    {
                      required: !disabled,
                      message: $t('page_material_warehousing_p_input'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('common_please_input') + $t('page_plan_maintenance_code')"
            />
          </a-form-item>
        </a-col>
        <a-col
          :span="24"
        >
          <a-form-item :label="$t('page_plan_maintenance_items')">
            <a-input
              :disabled="isEdit"
              :maxLength="64"
              v-decorator="[
                'name',
                { initialValue: dataSourse.name || '',
                  rules: [
                    {
                      required: true,
                      message: $t('page_material_warehousing_p_input'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('common_please_input') + $t('page_plan_maintenance_items')"
            />
          </a-form-item>
        </a-col>
        <a-col
          :span="24"
        >
          <a-form-item :label="$t('page_plan_maintenance_requirements')">
            <a-textarea
              :maxLength="300"
              v-decorator="['requirement',{ initialValue: dataSourse.requirement || ''}]"
              :placeholder="$t('common_please_input') + $t('page_plan_maintenance_requirements')"
              :rows="5"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col
          :span="24"
        >
          <a-form-item :label="$t('remark')" :label-col="{ span: 4 }" :wrapper-col="{ span: 17 }">
            <a-textarea
              :maxLength="100"
              v-decorator="['remark',{ initialValue: dataSourse.remark || '' }]"
              :placeholder="$t('common_please_input') + $t('remark')"
              :rows="5"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import { MaintainItemServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
const misp = new MaintainItemServiceProxy()

export default {
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    isEdit:{
      type: Boolean,
      default: false
    },
    data:{
      type: Object,
      default: () => ({})
    },
    maintainList: {
      type: Array,
      default: []
    }
  },
  data(){
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 17 },
      form: this.$form.createForm(this),
      loading: false,
      dataSourse: [],
      disabled: false
      
    }
  },
  watch:{
    visible:{
      handler(){
        if(this.visible){
          this.getDataSourse()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getDataSourse(){
      this.form.resetFields()
      this.dataSourse = JSON.parse(JSON.stringify(this.data))
    },
    handleCancel(){
      this.$emit('close',false)
      this.form.resetFields()
      this.disabled = false
    },
    handleOk(){
      this.form.validateFields((err, values) => {
        if(!err){
          this.loading = true
          Object.keys(values).forEach(key => {
            const item = values[key]
            values[key] = (values[key] && (typeof item) == 'string') ? values[key].replace(/\s*/g,"") : values[key]
          });
          if(this.isEdit){
            const data = {
              id: this.data.id,
              code: values.code,
              name: values.name,
              requirement: values.requirement,
              remark: values.remark
            }
            misp.editMaintainItem(data).then(() =>{
              this.$message.success(this.$t('page_mdc_setting_edit_success'))
              this.$emit('close',true)
              this.form.resetFields()
              this.loading = false
            }).catch(() => {this.loading = false})
          } else {
            misp.createMaintainItem(values).then(() => {
              this.$message.success(this.$t('create_success'))
              this.$emit('close',true)
              this.form.resetFields()
              this.loading = false
            }).catch(() => {this.loading = false})
          }
        }
      })
    },
  handleSelectChange(val){
    if(val) {
      this.form.setFieldsValue({['code']:''})
      this.disabled = true
    }else {
      this.disabled = false
    }
    }
  }
}
</script>

<style>

</style>
